import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      fieldPermissions: state => state.user.data.permissions,
    }),
  },
  methods: {
    canView () {
      return true
    },
    canEdit () {
      if (!this.site) {
        alert('Missing site info on section ' + this.section + '!')
        return false
      }
      const siteKey = 'site-' + this.site.id
      // allow everything on one specific site
      if (this.fieldPermissions[siteKey] && this.fieldPermissions[siteKey]['*'] && this.fieldPermissions[siteKey]['*'].edit) {
        return true
      }
      // allow some things on one specific site
      if (this.fieldPermissions[siteKey] && this.fieldPermissions[siteKey][this.section] && this.fieldPermissions[siteKey][this.section].edit) {
        return true
      }
      // allow everything
      if (this.fieldPermissions['site-*'] && this.fieldPermissions['site-*']['*'] && this.fieldPermissions['site-*']['*'].edit === 1) {
        return true
      }
      // allow something on all sites
      if (this.fieldPermissions['site-*'] && this.fieldPermissions['site-*'][this.section] && this.fieldPermissions['site-*'][this.section]) {
        return true
      }
      return false
    },
    isReadOnly () {
      return !this.canEdit()
    },
    accessViewSectors () {
      return this.fieldPermissions.views.view_sectors === 1
    },
    accessViewCells () {
      return this.fieldPermissions.views.view_cells === 1
    },
    accessViewContracts () {
      return this.fieldPermissions.views.view_contracts === 1
    },
    accessViewHealthPermits () {
      return this.fieldPermissions.views.view_health_permits === 1
    },
    accessViewTenants () {
      return this.fieldPermissions.views.view_tenants === 1
    },
    accessViewRollout () {
      return this.fieldPermissions.views.view_rollout === 1
    },
    accessViewEquipmentAirConditioning () {
      return this.fieldPermissions.views.view_equipment_air_conditioning === 1
    },
    accessViewEquipmentDcSystem () {
      return this.fieldPermissions.views.view_equipment_dc_system === 1
    },
    accessViewEquipmentBattery () {
      return this.fieldPermissions.views.view_equipment_battery === 1
    },
    accessViewEquipmentShelter () {
      return this.fieldPermissions.views.view_equipment_shelter === 1
    },
    accessViewEquipmentTower () {
      return this.fieldPermissions.views.view_equipment_tower === 1
    },
    accessViewContacts () {
      return this.fieldPermissions.views.view_contacts === 1
    },
    accessViewProjects () {
      return this.fieldPermissions.views.view_projects === 1
    },
    editContacts () {
      return this.fieldPermissions.views.edit_contacts === 1
    },
    editProjects () {
      return this.fieldPermissions.views.edit_projects === 1
    },
  },
}
